import { useState } from "react";
import TabbedMenu from "./TabbedMenu";

## Interactive Example

export function InteractiveTabs() {
const [currentTab, setCurrentTab] = useState("tab1");
const [tabCount, setTabCount] = useState(3);
const menuItems = Array.from({ length: tabCount }, (unused, i) => ({
text: "Tab " + (i + 1),
selected: currentTab === "tab" + (i + 1),
onClick: () => setCurrentTab("tab" + (i + 1)),
}));
return (

<div>
  <label style={{ display: "block", marginBottom: "1rem" }}>
    Tab Count:{" "}
    <input
      type="number"
      value={tabCount}
      onChange={(e) => setTabCount(Number(e.target.value))}
      min={1}
      max={10}
      style={{ width: "60px" }}
    />
  </label>
  <TabbedMenu menuItems={menuItems} />
  <p>Current tab: **{currentTab}**</p>
</div>
); }

<InteractiveTabs />

---

## Basic Navigation

<TabbedMenu
  menuItems={[
    { text: "Dashboard", selected: true, onClick: () => {} },
    { text: "Projects", selected: false, onClick: () => {} },
    { text: "Settings", selected: false, onClick: () => {} },
  ]}
/>

---

## With Link Paths

<TabbedMenu
  menuItems={[
    { text: "Home", selected: false, path: "/" },
    { text: "About", selected: true, path: "/about" },
    { text: "Contact", selected: false, path: "/contact" },
  ]}
/>

---

## Many Tabs

<TabbedMenu
  menuItems={[
    { text: "Overview", selected: true, onClick: () => {} },
    { text: "Analytics", selected: false, onClick: () => {} },
    { text: "Reports", selected: false, onClick: () => {} },
    { text: "Users", selected: false, onClick: () => {} },
    { text: "Settings", selected: false, onClick: () => {} },
    { text: "Billing", selected: false, onClick: () => {} },
  ]}
/>

---

## With Hidden Tab

The middle tab below has `hidden: true`:

<TabbedMenu
  menuItems={[
    { text: "Visible Tab 1", selected: true, onClick: () => {} },
    { text: "Hidden Tab", selected: false, hidden: true, onClick: () => {} },
    { text: "Visible Tab 2", selected: false, onClick: () => {} },
  ]}
/>
